<template>
  <div class="td-news-wrap">

    <div
      v-for="(newsItem, index) in news"
      :key="index"
      class="news-row"
    >
      <TdNewsItem
        :news-index="index"
        :news-text="newsItem.news"
        :timestamp="newsItem.timestamp"
      />
    </div>

    <div class="separator"></div>

  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import TdNewsItem from './TdNewsItem';

export default {
  name: "TdNews",
  components: {
    TdNewsItem
  },
  computed: {
    ...mapState('td', ['news']),
  },
  methods: {
    ...mapActions('td', ['getTdNews']),
  },
  mounted() {
    this.getTdNews();

  }

}
</script>

<style scoped>

</style>
